<template>
  <div class="feature">
    <div class="top-banner">
      教 学 特 色
    </div>
    <!-- 讲师团队 -->
    <div class="feature-teachers" v-if="false">
      <div class="g-box">
        <div class="top-title">讲师团队</div>
        <!-- <div class="sub-title">
          每个核心变量对自考结果影响权重如下
        </div> -->
        <div class="content">
          <div class="swiper-container feature-swiper" id="swiper">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, i) in teachersList"
                :key="i"
              >
                <div class="items">
                  <div class="item" v-for="el in item" :key="el.id">
                    <img :src="el.image" :alt="el.title" class="avatar" />
                    <div class="tit">
                      {{ el.title }}
                    </div>
                    <div class="intro">
                      {{ el.subtitle }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination my-pagi"></div>
          </div>
        </div>
      </div>
    </div>
    <teacher2 />

    <!-- 教研团队 -->
    <div class="feature-research">
      <div class="g-box">
        <div class="top-title">教研团队</div>
        <!-- <div class="sub-title">每个核心变量对自考结果影响权重如下</div> -->
        <div class="content">
          <div class="swiper-container research-swiper" id="swiper2">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, i) in researchList"
                :key="i"
              >
                <div class="items">
                  <div class="item" v-for="(el, j) in item" :key="j">
                    <img :src="el.image" alt="" class="img" />
                    <div class="bottom">{{ el.title }}</div>
                    <div class="inner">
                      <div class="top">{{ el.title }}</div>
                      <div class="con">
                        {{ el.subtitle }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-pagination2 swiper-pagination my-pagi"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 后勤管理 -->
    <div class="feature-logistics">
      <div class="g-box">
        <div class="top-title">后勤管理</div>
        <!-- <div class="sub-title">每个核心变量对自考结果影响权重如下</div> -->
        <div class="content">
          <div
            class="item"
            v-for="(item, i) in logisticsList"
            :key="item.id"
            :class="i % 2 ? 'reserve' : ''"
          >
            <div class="le">
              <img :src="item.image" alt="" class="img" />
              <div class="con">
                <div class="tit">{{ item.title }}</div>
                <div class="line"></div>
              </div>
            </div>
            <div class="ri">
              <div class="el" v-for="(el, j) in item.content" :key="j">
                <img :src="el" alt="" class="img" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
import teacher2 from "./components/teacher2";
import Swiper from "swiper";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      teachersList: [],
      researchList: [],
      logisticsList: []
    };
  },
  components: { teacher2 },
  async mounted() {
    // 讲师团队
    const menuId = this.getMenuId("教学特色-特色展示-讲师团队");
    if (menuId) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId
      });
      const arr = [];
      for (let i = 0; i < data.length; i += 4) {
        arr.push(data.slice(i, i + 4));
      }
      this.teachersList = arr;
      this.userSwiper();
    }
    // 教研团队
    const menuId1 = this.getMenuId("教学特色-特色展示-教研团队");
    if (menuId1) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId1
      });
      const arr = [];
      for (let i = 0; i < data.length; i += 4) {
        arr.push(data.slice(i, i + 4));
      }
      this.researchList = arr;
      this.userSwiper2();
    }
    // 后勤管理
    const menuId2 = this.getMenuId("教学特色-特色展示-后勤管理");
    if (menuId2) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId2
      });
      data.forEach(item => {
        item.content = item.content.split(",");
      });
      this.logisticsList = data;
      console.log(data, "dat");
    }
  },
  methods: {
    userSwiper() {
      new Swiper("#swiper", {
        loop: false,
        observer: true,
        observerParents: true,
        watchSlidesVisibility: true,
        pagination: {
          el: ".swiper-pagination"
        }
      });
    },
    userSwiper2() {
      new Swiper("#swiper2", {
        loop: false,
        observer: true,
        observerParents: true,
        watchSlidesVisibility: true,
        pagination: {
          el: ".swiper-pagination2"
        }
      });
    }
  }
};
</script>
<style lang="less">
.feature {
  .top-banner {
    padding-top: 80px;
    text-align: center;
    height: 280px;
    background: url("../../assets/img/feature.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    font-size: 60px;
    color: #fff;
    line-height: 84px;
    letter-spacing: 8px;
  }
  //  讲师团队
  &-teachers {
    padding: 80px 0 70px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #0f53ff;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #272727;
    }
    .content {
      margin-top: 60px;
      .items {
        display: flex;
        .item {
          margin-right: 27px;
          padding: 50px 40px;
          width: 280px;
          height: 390px;
          background: #fff;
          border-radius: 10px;
          border: 1px solid #e0e0e0;
          box-sizing: border-box;
          text-align: center;
          .avatar {
            width: 160px;
            height: 160px;
            border: 4px solid #fff;
            border-radius: 50%;
          }
          .tit {
            padding-top: 28px;
            font-size: 20px;
            font-weight: 600;
            color: #000;
          }
          .intro {
            padding-top: 10px;
            font-size: 14px;
            color: #656878;
            line-height: 24px;
          }
        }
        .item:nth-child(4n) {
          margin-right: 0;
        }
        .item:hover {
          background: #0f53ff;
          .tit {
            color: #fff;
          }
          .intro {
            color: #fff;
          }
        }
      }
    }
  }
  // 教研团队
  &-research {
    padding-top: 80px;
    height: 720px;
    background: url("../../assets/img/research-bg.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #fff;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.6);
    }
    .content {
      margin-top: 60px;
      .items {
        display: flex;
        .item {
          position: relative;
          margin-right: 3px;
          width: 298px;
          height: 360px;
          .img {
            position: absolute;
            left: 0;
            top: 0;
            width: 298px;
            height: 360px;
          }
          .bottom {
            position: absolute;
            bottom: 0;
            padding: 16px 20px;
            height: 60px;
            width: 100%;
            background: rgba(0, 0, 0, 0.6);
            font-size: 20px;
            box-sizing: border-box;
            font-weight: 600;
            color: #fff;
          }
          .inner {
            position: absolute;
            left: 0;
            top: 0;
            padding: 20px;
            display: none;
            width: 298px;
            height: 360px;
            box-sizing: border-box;
            background: rgba(0, 0, 0, 0.6);
            .top {
              font-size: 20px;
              font-weight: 600;
              color: #fff;
            }
            .con {
              padding-top: 18px;
              font-size: 16px;
              color: #fff;
            }
          }
        }
        .item:nth-child(4n) {
          margin-right: 0;
        }
        .item:hover {
          .inner {
            display: block;
          }
        }
      }
    }
  }
  // 后勤管理
  &-logistics {
    padding: 80px;
    background: #f1f1f2;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #0f53ff;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #272727;
    }
    .content {
      margin-top: 60px;
      .item {
        display: flex;
        .le {
          position: relative;
          padding: 40px 30px;
          width: 300px;
          height: 240px;
          box-sizing: border-box;
          .img {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 300px;
            height: 240px;
          }
          .con {
            position: relative;
            z-index: 11;
            .tit {
              font-size: 32px;
              color: #fff;
              line-height: 60px;
            }
            .line {
              margin-top: 60px;
              width: 52px;
              height: 2px;
              background: #fff;
            }
          }
        }
        .ri {
          display: flex;
          .img {
            display: block;
            width: 300px;
            height: 240px;
          }
        }
      }
      .item.reserve {
        flex-direction: row-reverse;
      }
    }
  }
}
.feature-swiper {
  padding-bottom: 60px;
  --swiper-theme-color: #0f53ff;
}
.research-swiper {
  padding-bottom: 60px;
  --swiper-theme-color: #fff;
}
</style>
